import axios from "axios";
import { useNavigate } from "react-router-dom";
import KeycloakService from "./KeycloakService";
import { getAxios } from "./NotifcationServices";

const HttpMethods = {
  GET: "GET",
  POST: "POST",
  DELETE: "DELETE",
  PUT: "PUT",
};

const _axios = axios.create();

const configure = () => {
  _axios.interceptors.request.use((config) => {
    if (KeycloakService.isLoggedIn()) {
      const cb = () => {
        sessionStorage.setItem(
          process.env.REACT_APP_TOKEN_REFERENCE,
          KeycloakService.getToken() || "no-token"
        );
        if (config && config.headers) {
          config.headers.Authorization = `Bearer ${KeycloakService.getToken()}`;
          return Promise.resolve(config);
        }
      };
      getAxios();
      return KeycloakService.updateToken(cb);


    }
  });

  // _axios.interceptors.response.use((response) => {
  //   if (response.status === 401) {
  //     KeycloakService.doLogout();
  //   } else {
  //     return response;
  //   }
  // });
};

const getAxiosClient = () => _axios;

const HttpService = {
  HttpMethods,
  configure,
  getAxiosClient,
};

export default HttpService;
